<template>
  <main v-if="viewRelease" class="landing">
    <img class="app-artwork" src="@/assets/branding/Minimal.png" alt="EWERT" />

    <div class="release-copy">
      <h1 class="title">Мы выпустили приложение!</h1>
    </div>

    <div class="download-actions" aria-label="Скачать приложение EWERT">
      <a
        class="download-button download-button--android"
        href="https://storage.yandexcloud.net/ewert/app/EWERT.apk"
      >
        Скачать для Android
      </a>
      <a
        class="download-button download-button--ios"
        href="https://apps.apple.com/ru/app/ewert/id6802482438"
      >
        Скачать для iPhone
      </a>
    </div>
  </main>
</template>

<script>
import { isStandaloneLaunch } from '@/utils/pwaMode'

export default {
  name: 'HomeView',
  data() {
    return {
      viewRelease: false
    }
  },
  mounted() {
    if (isStandaloneLaunch()) {
      this.$router.push('/login')
      return
    }

    this.viewRelease = true
  }
}
</script>

<style scoped>
.landing {
  min-height: 100svh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  padding: max(28px, env(safe-area-inset-top)) 20px max(28px, env(safe-area-inset-bottom));
  overflow: hidden;
  background:
    radial-gradient(circle at 50% 32%, rgba(172, 231, 21, 0.14), transparent 34%),
    #000;
  color: #fff;
}

.app-artwork {
  width: min(58vw, 230px);
  max-height: 280px;
  object-fit: contain;
  margin-bottom: 28px;
  filter: drop-shadow(0 22px 36px rgba(172, 231, 21, 0.14));
}

.release-copy {
  text-align: center;
}

.title {
  max-width: 360px;
  margin: 0;
  color: #fff;
  font-size: clamp(25px, 7vw, 34px);
  font-weight: 600;
  line-height: 1.16;
  text-align: center;
  letter-spacing: -0.02em;
}

.download-actions {
  width: min(100%, 360px);
  display: grid;
  gap: 12px;
  margin-top: 30px;
}

.download-button {
  min-height: 52px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  padding: 13px 18px;
  border: 1px solid transparent;
  border-radius: 14px;
  font-family: 'Bounded';
  font-size: 14px;
  font-weight: 600;
  line-height: 1.2;
  text-align: center;
  text-decoration: none;
  transition: transform 0.2s ease, background-color 0.2s ease;
}

.download-button:hover {
  transform: translateY(-1px);
}

.download-button:focus-visible {
  outline: 3px solid rgba(172, 231, 21, 0.4);
  outline-offset: 3px;
}

.download-button--android {
  background: #ace715;
  color: #111;
}

.download-button--android:hover {
  background: #9bd413;
}

.download-button--ios {
  border-color: rgba(255, 255, 255, 0.18);
  background: rgba(255, 255, 255, 0.08);
  color: #fff;
}

.download-button--ios:hover {
  background: rgba(255, 255, 255, 0.14);
}

@media (max-height: 620px) {
  .landing {
    justify-content: flex-start;
    overflow-y: auto;
  }

  .app-artwork {
    width: min(42vw, 170px);
    max-height: 180px;
    margin-bottom: 20px;
  }

  .download-actions {
    margin-top: 22px;
  }
}
</style>
